import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/components/pages/Home";
import ServicesOverview from "@/components/pages/ServicesOverview";
import RPO from "@/components/pages/RPO";
import BPO from "@/components/pages/BPO";
import KPO from "@/components/pages/KPO";
import AIAtA4Assist from "@/components/pages/AIAtA4Assist";
import Industries from "@/components/pages/Industries";
import CaseStudies from "@/components/pages/CaseStudies";
import About from "@/components/pages/About";
import Careers from "@/components/pages/Careers";
import Contact from "@/components/pages/Contact";
import { captureAttributionOnLoad } from "@/lib/attribution";

function App() {
  useEffect(() => {
    captureAttributionOnLoad();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesOverview />} />
            <Route path="/services/rpo" element={<RPO />} />
            <Route path="/services/bpo" element={<BPO />} />
            <Route path="/services/kpo" element={<KPO />} />
            <Route path="/ai" element={<AIAtA4Assist />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
